import style from "./Header.module.css";
import React from "react";
import { Link } from "react-router-dom";
import Logo from "./Logo";
import { connect } from "react-redux";
import { PERSISTENCE_KEY, IS_NZ, setIS_NZ } from "../constants";
import { doesQuoteMatchOpportunity, quoteItemCount } from "../redux/selectors";
import { setFinanceType } from "../redux/actions";
import {
  Popover,
  OverlayTrigger,
  Button,
  Navbar,
  Nav,
  Form,
  Badge
} from "react-bootstrap";

function Header(props) {
  const handleLogout = e => {
    e.preventDefault();

    window.sessionStorage.removeItem(PERSISTENCE_KEY);

    window.location = props.returnUrl;
  };
  if(props !== null && props.opportunity !== null) {
    setIS_NZ(props.opportunity.OpportunityType)
  }

  return (
    <Navbar bg="light" variant="light">
      <Navbar.Brand as={Link} to="/">
        <Logo className={style.logo} />
      </Navbar.Brand>

      <Nav>
        {props.opportunity && (
          <OverlayTrigger
            trigger={"click"}
            placement="bottom"
            overlay={
              <Popover id="popover-opportunity-details">
                <Popover.Title>Opportunity Details</Popover.Title>
                <Popover.Content>
                  <p>
                    <strong>ID:</strong>{" "}
                    <a
                      href={`https://${process.env.REACT_APP_SFDC_DOMAIN}/lightning/r/Opportunity/${props.opportunity.ID}/view`}
                      rel="noopener noreferrer"
                    >
                      {props.opportunity.UniqueID}
                    </a>
                  </p>
                  <p>
                    <strong>Name:</strong> {props.opportunity.Name}
                  </p>
                  <p>
                    <strong>Is MSA:</strong>{" "}
                    {props.opportunity.IsMSA ? "Yes" : "No"}
                  </p>
                  <p>
                    <strong>Finance Type:</strong>{" "}
                    {props.opportunity.FinanceType}
                  </p>
                  <p>
                    <strong>Opp Type:</strong>{" "}
                    {props.opportunity.OpportunityType}
                  </p>
                  <p>
                    <strong>Tender Code:</strong>{" "}
                    {props.opportunity.TenderCode || "N/A"}
                  </p>
                  <p>
                    <strong>Customer No.:</strong>{" "}
                    {props.opportunity.CustomerNumber}
                  </p>
                  <p>
                    <strong>Derived Price List: </strong>
                    {props.derivedCustomerGroup
                      ? props.derivedCustomerGroup.code
                      : "N/A"}
                  </p>
                </Popover.Content>
              </Popover>
            }
          >
            <Nav.Link as={Button} variant="link" className="dropdown-toggle">
              <strong>Opp: </strong>
              {props.opportunity.Name}
            </Nav.Link>
          </OverlayTrigger>
        )}

        <OverlayTrigger
          trigger={"click"}
          placement="bottom"
          overlay={
            <Popover id="popover-quote-details">
              <Popover.Title>Quote Details</Popover.Title>
              <Popover.Content>
                <p>
                  <strong>ID:</strong>{" "}
                  {props.quote.qid ? (
                    <a
                      href={`https://${process.env.REACT_APP_SFDC_DOMAIN}/lightning/r/Quote/${props.quote.qid}/view`}
                      rel="noopener noreferrer"
                    >
                      {props.quote.qid}
                    </a>
                  ) : (
                    "N/A"
                  )}
                </p>
                <p>
                  <strong>Name: </strong>
                  {props.quote.name || "N/A"}
                </p>
                <p>
                  <strong>Is MSA:</strong> {props.quote.isMsa ? "Yes" : "No"}
                </p>
                <p>
                  <strong>Finance Type:</strong>{" "}
                  {props.quote.finance.financeType}
                </p>
                <p>
                  <strong>Opp Type:</strong>{" "}
                  {props.quote.opportunityType || "N/A"}
                </p>
                <p>
                  <strong>Tender Code:</strong>{" "}
                  {props.quote.tenderCode || "N/A"}
                </p>
                <p>
                  <strong>Customer No.:</strong>{" "}
                  {props.quote.sfdcCustomerNumber || "N/A"}
                </p>
                <p>
                  <strong>Saved Price List:</strong>{" "}
                  {props.quote.customerGroupCode}
                </p>
              </Popover.Content>
            </Popover>
          }
        >
          <Nav.Link as={Button} variant="link" className="dropdown-toggle">
            <strong>Quote: </strong>
            {props.quote.name || props.quote.qid || "NEW QUOTE"}{" "}
            <span className="caret" />
          </Nav.Link>
        </OverlayTrigger>
      </Nav>

      <Nav className="ml-auto">
        {props.doesQuoteMatchOpportunity && (
          <Form inline className="px-2">
            <Form.Group controlId="headerFinanceType">
              <Form.Label className="text-muted">
                Finance Type:&nbsp;
              </Form.Label>
              <Form.Control
                size="sm"
                as="select"
                onChange={e => props.setFinanceType(e.target.value)}
                value={props.quote.finance.financeType}
              >
                <option value={IS_NZ ? "CFNZ" : "CFA"}>{IS_NZ ? "CFNZ" : "CFA"}</option>
                <option value="CASH">Cash</option>
              </Form.Control>
            </Form.Group>
          </Form>
        )}

        {props.customer && (
          <Navbar.Text className="px-2">
            <strong>User:</strong> {props.customer.firstname}{" "}
            {props.customer.lastname}
          </Navbar.Text>
        )}

        {props.doesQuoteMatchOpportunity && (
          <Nav.Link as={Link} to="/quote/">
            Quote{" "}
            <Badge pill variant="primary" className="align-top">
              {props.quoteItemCount}
            </Badge>
          </Nav.Link>
        )}

        <Nav.Link href={props.returnUrl} rel="noopener noreferrer">
          Salesforce
        </Nav.Link>

        <Nav.Link as={Button} variant="link" onClick={handleLogout}>
          Log out
        </Nav.Link>
      </Nav>
    </Navbar>
  );
}

export default connect(
  state => {
    const {
      derivedCustomerGroup,
      opportunity,
      returnUrl,
      quote,
      customer
    } = state;
    return {
      derivedCustomerGroup,
      opportunity,
      quoteItemCount: quoteItemCount(state),
      doesQuoteMatchOpportunity: doesQuoteMatchOpportunity(state),
      returnUrl,
      quote,
      customer
    };
  },
  { setFinanceType }
)(Header);
